import * as React from "react";
import { forwardRef, memo } from "react";
const SvgPs = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 6 3", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#007A3D", d: "M0 0h6v3H0z" }), /* @__PURE__ */ React.createElement("path", { fill: "#FFF", d: "M0 0h6v2H0z" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h6v1H0z" }), /* @__PURE__ */ React.createElement("path", { fill: "#CE1126", d: "M0 0l2 1.5L0 3z" }));
const ForwardRef = forwardRef(SvgPs);
const Memo = memo(ForwardRef);
export default Memo;
